export default __webpack_public_path__ + "static-front/media/extendCertificateIcon.e418fac9.svg";